export default __webpack_public_path__ + "static/media/register__loader.044ce5bf.gif";